import Icon from '../components/Icon';

const CheckSm = Icon(
  'check-sm',
  <>
    <path d="M15.293 8.543a1 1 0 1 1 1.414 1.414l-5.5 5.5a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 1 1 1.414-1.414l1.793 1.793z" />
  </>
);

export default CheckSm;
